import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
class PromotedItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
        };
    }
    componentDidMount() {
        // const { src } = this.props;

        const imageLoader = new Image();
        imageLoader.src = this.props.data.img;

        imageLoader.onload = () => {
            this.setState({ loaded: true });
        };
        imageLoader.onerror = () => {
            this.setState({ loaded: true });
        };
    }
    render() {
        const regex = /(<([^>]+)>)/gi;
        let name = this.props.data.type.name;
        try {
            name = name.replace(regex, '');
            name.replace('&amp;', '&');
        } catch (err) {}
        return (
            <div className="promoted-item-container" onClick={() => this.props.onOpen(this.props.data.contentId)}>
                {this.state.loaded && (
                    <div
                        className="promoted-item-image-loaded"
                        style={{
                            backgroundImage: `url(${this.props.data.img})`,
                        }}
                    />
                )}
                {!this.state.loaded && (
                    <div className="promoted-item-image-not-loaded">
                        <CircularProgress style={{ color: this.props.primaryColor }} />
                    </div>
                )}
                <div
                    className="promoted-item-type"
                    style={{
                        backgroundColor: this.props.data.type.color,
                    }}
                    dangerouslySetInnerHTML={{ __html: this.props.data.type.name }}
                ></div>
                <div className="promoted-name-container">
                    <div className="promoted-name" dangerouslySetInnerHTML={{ __html: this.props.data.name.replace(/&nbsp;/g, '') }}></div>
                </div>
            </div>
        );
    }
}
PromotedItem.propTypes = {
    data: PropTypes.object.isRequired,
    onOpen: PropTypes.func.isRequired,
};

export default PromotedItem;
